<template>
	<div class="product h-100 d-flex flex-column">
		<div
			class="animation__wrapper"
			:class="{ 'added-to-cart': addedToCart }"
		>
			<img
				:src="`${product.thumbnail}?w=500&h=500&fit=crop`"
				:alt="product.title"
				v-if="product.thumbnail"
			/>
			<img
				src="../assets/img/placeholder.svg"
				:alt="product.title"
				v-else
			/>
		</div>
		<div class="product__description flex-grow-1">
			<h4 class="mt-0">{{ product.title }}</h4>
			<p class="m-0" v-if="product.description">
				{{ product.description }}
			</p>
		</div>
		<!-- Staff ID -->
		<div class="staff-input" v-if="product.require_staff_id">
			<input
				type="text"
				class="form-control"
				v-model="staff_id"
				placeholder="Personeelsnummer..."
				:disabled="!allowStaffIdEditing"
			/>
		</div>
		<!-- End Staff ID -->
		<div class="d-flex">
			<input
				type="number"
				min="1"
				class="form-control ht-100"
				v-model="quantity"
			/>
			<button
				@click="addToCart"
				class="btn btn--accent btn--block"
				:disabled="
					quantity < 0 ||
					addingToCart ||
					!(!product.require_staff_id || staff_id)
				"
			>
				<span v-if="!addingToCart && !addedToCart">Toevoegen</span>
				<span v-if="addingToCart">
					<i class="fa fa-spin fa-circle-o-notch"></i>
				</span>
				<span v-if="addedToCart">
					<i class="fa fa-check mr-1"></i> Toegevoegd!
				</span>
			</button>
		</div>
	</div>
</template>

<script>
export default {
	props: ["product"],
	computed: {
		user() {
			return this.$store.getters.user;
		},
		allowStaffIdEditing() {
			return this.$store.getters.user &&
				this.$store.getters.user.current_staff_id
				? false
				: true;
		},
	},
	watch: {
		user(newVal, oldVal) {
			this.staff_id = this.product.require_staff_id
				? newVal.current_staff_id
				: "";
		},
	},
	data() {
		return {
			addingToCart: false,
			addedToCart: false,
			quantity: 1,
			staff_id: "",
		};
	},
	mounted() {
		this.staff_id =
			this.$store.getters.user && this.product.require_staff_id
				? this.$store.getters.user.current_staff_id
				: "";
	},
	methods: {
		addToCart() {
			if (this.addingToCart) {
				return;
			}

			this.addingToCart = true;

			this.$http
				.post("/cart/items/" + this.product.id, {
					quantity: this.quantity,
					staff_id: this.staff_id,
					thumbnail: this.product.thumbnail,
				})
				.then((res) => {
					console.log(res);
					this.addingToCart = false;
					this.addedToCart = true;
					this.$root.$emit("cart-changed");

					window.setTimeout(() => {
						this.addedToCart = false;
					}, 2000);
				})
				.catch((err) => {
					console.log(err);
					this.addingToCart = false;
				});
		},
	},
};
</script>

<style lang="scss" scoped>
.product {
	background-color: $white;
	position: relative;

	.animation__wrapper {
		position: relative;

		img {
			-webkit-filter: grayscale(0%);
			opacity: 1;
			transition: all 0.2s ease-in-out;
		}

		&:before {
			height: 100px;
			width: 100px;
			content: "\F00C";
			font-family: "FontAwesome";
			top: 50%;
			position: absolute;
			transform: translate(-50%, -50%) scale(0, 0);
			opacity: 0;
			text-align: center;
			font-size: 60px;
			left: 50%;
			color: $white;
			border-radius: 100%;
			background-color: $accent;
			transition: all 0.2s ease-in-out;
		}

		&.added-to-cart {
			&:before {
				opacity: 1 !important;
				z-index: 99;
				transform: translate(-50%, -50%) scale(1, 1);
			}

			img {
				-webkit-filter: grayscale(100%);
				opacity: 0.5;
			}
		}
	}

	img {
		width: 100%;
		height: auto;
		transition: all 0.15s ease-in-out;
	}

	.product__description {
		padding: 20px;

		p {
			font-size: $text-sm;
		}
	}

	.staff-input {
		input {
			padding: 10px 20px;
			outline: none;
			height: auto;
			border-width: 1px 0 0;
			border-color: $border !important;
		}
	}

	input[type="number"] {
		height: 100%;
		border-width: 1px 0 0 0;
		width: 70px;
		text-align: center;
	}
}
</style>

